<template>
  <NavigationLayout
    :navigationBarStyle="{
      'top': 'var(--safe-area-inset-top, 0px)',
    }"
    :navigationContentStyle="{
      'padding-top': 'calc(44px + var(--safe-area-inset-top, 0px))',
    }"
  >
    <div class="ly_cont" slot="contents">
      <!-- CoinPurchasePending -->
      <coin-purchase-pending />
      <PrimaryButton @click.native="moveTo({ name: 'mypage' })">
        {{ $t('order_details__button__back_to_coin_purchase') }}
      </PrimaryButton>
    </div>
  </NavigationLayout>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import NavigationLayout from '@/components/NavigationLayout.vue'
import PrimaryButton from '@/components/PrimaryButton.vue'
import { LanguageQueryHandler } from '@/mixins/LanguageQuery'
import CoinPurchasePending from '@/components/Mypage/CoinPurchasePending.vue'
import { RawLocation } from 'vue-router'

@Component({
  components: {
    NavigationLayout,
    CoinPurchasePending,
    PrimaryButton,
  },
})
export default class MyPageCoinPurchasePending extends Mixins(
  LanguageQueryHandler
) {
  moveTo(location: RawLocation) {
    this.$router.push(location).catch(() => {
      // Nothing to do
    })
  }
}
</script>

<style scoped>
.ly_cont {
  position: relative;
  height: auto;
  min-height: 100%;

  padding: 24px 16px 24px 16px;

  @media (min-width: 800px) {
    width: 800px;
    margin: 0 auto;
  }
}

.primary_button {
  margin-top: 24px;
}
</style>
